import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

type Props = {}

const Alert = (props: Props) => {
    const [show, setShow] = useState(true);

    const handleClose = () => setShow(false);

    return (

        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>SCAMMER ALERT</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Please be aware, recently, there are scammers impersonating QA Finance, saying you are approved for a loan, asking you to make a payment for some sort of insurance or tax.</p>
                <p>These are all scams. Please DO NOT respond!</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleClose}>
                Close
                </Button>
            </Modal.Footer>
        </Modal>

    );
}

export default Alert;